import React from 'react';
import { createRoot } from 'react-dom/client';

import App from '../../../app/RecommendationsModalApp';

const container = document.getElementById('recommendationsModal');
const root = createRoot(container!);
root.render(<App />);
